<template>

  <slick id="services_pres_slick" class="prespective-slick-slider"
  ref="slick"
  :options="slickOptions"
  @afterChange="handleAfterChange"
  @beforeChange="handleBeforeChange"
  @breakpoint="handleBreakpoint"
  @destroy="handleDestroy"
  @edge="handleEdge"
  @init="handleInit"
  @reInit="handleReInit"
  @setPosition="handleSetPosition"
  @swipe="handleSwipe"
  @lazyLoaded="handleLazyLoaded"
  @lazyLoadError="handleLazeLoadError">
  
  <slot></slot>
</slick>
</template>
<script>
  import 'slick-carousel/slick/slick.css';
  import Slick from 'vue-slick';

  export default {

    name: "carousel",
    components: { Slick },
    props:{
      agentDesktop:{
        required:true,
        type:Boolean
      },
    },
    data() {
      return {
        window: {
          width: 0,
          height: 0
        },
        slickOptions: {
          slidesToShow: 6,
          infinite: true,
          dots: false,
          arrows: true,
          dotsClass:'primary-dots transparent-bg-dots slick-dots',
          nextArrow: `<button class="button next-btn invisible-btns" aria-label="Next" type="button">
          <i class="fas fa-caret-right"></i>
          </button>`,
          prevArrow: `<button class="button prev-btn invisible-btns" aria-label="Prev" type="button">
          <i class="fas fa-caret-left"></i>
          </button>`,
          responsive: [
          {
            breakpoint: 1367,
            settings: {
              slidesToShow: 5,
            }
          },
          {
            breakpoint: 1088,
            settings: {
              slidesToShow: 4,
            }
          },
          
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 522,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 421,
            settings: {
              slidesToShow: 1,
            }
          },
          ]

          
                // Any other options that can be got from plugin documentation
              },
            };
          },

    // All slick methods can be used too, example here
    created(){
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      next() {
        this.$refs.slick.next();
      },

      prev() {
        this.$refs.slick.prev();
      },

      reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
              this.$refs.slick.reSlick();
            });
          },

        // Events listeners
        handleAfterChange(event, slick, currentSlide) {
          if($('#services_pres_slick .slick-slide').length >= 7 || $('#services_pres_slick .slick-slide').length >= 7 && this.window.width < 1367){
            if(this.agentDesktop || this.window.width > 768){
              $('#services_pres_slick .prespective-3d-first').removeClass('prespective-3d-first');
              $('#services_pres_slick .prespective-3d-last').removeClass('prespective-3d-last');
              let activeSlides = $('#services_pres_slick .slick-slide.slick-active');
              let firstSlide = $('#services_pres_slick .slick-slide.slick-active').first().addClass('prespective-3d-first');
              let lastSlide = $('#services_pres_slick .slick-slide.slick-active').last().addClass('prespective-3d-last');
            }
          }
        },
        handleBeforeChange(event, slick, currentSlide, nextSlide) {

          // console.log(nextSlide);
          
        },
        handleBreakpoint(event, slick, breakpoint) {

          // console.log('handleBreakpoint', event, slick, breakpoint);
        },
        handleDestroy(event, slick) {
          // console.log('handleDestroy', event, slick);
        },
        handleEdge(event, slick, direction) {
          // console.log('handleEdge', event, slick, direction);
        },
        handleInit(event, slick) {
          if($('#services_pres_slick .slick-slide').length >= 7 || $('#services_pres_slick .slick-slide').length >= 7 && this.window.width < 1367){
            if(this.agentDesktop || this.window.width > 768){
              let activeSlides = $('#services_pres_slick .slick-slide.slick-active');
              let firstSlide = $('#services_pres_slick .slick-slide.slick-active').first().addClass('prespective-3d-first');
              let lastSlide = $('#services_pres_slick .slick-slide.slick-active').last().addClass('prespective-3d-last');
            }
          }
          
          

          // console.log('handleInit', event, slick);
        },
        handleReInit(event, slick) {
          // console.log('handleReInit', event, slick);
        },
        handleSetPosition(event, slick) {
          // console.log('handleSetPosition', event, slick);
        },
        handleSwipe(event, slick, direction) {
          // console.log('handleSwipe', event, slick, direction);
        },
        handleLazyLoaded(event, slick, image, imageSource) {
          // console.log('handleLazyLoaded', event, slick, image, imageSource);
        },
        handleLazeLoadError(event, slick, image, imageSource) {
          // console.log('handleLazeLoadError', event, slick, image, imageSource);
        },
      },
    }
  </script>
  <style lang="scss">


</style>
